(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-emberk-faq"] && !Shopify.designMode) return;
  try {
    
/**
 * Emberk FAQ Section
 * Handles search, category filtering, and accordion functionality
 */

class EmberkFAQ {
  /**
   * @param {HTMLElement} section - The FAQ section element
   */
  constructor(section) {
    this.section = section;
    /** @type {HTMLInputElement | null} */
    this.searchInput = section.querySelector('.emberk-faq__search-input');
    /** @type {HTMLButtonElement | null} */
    this.searchClear = section.querySelector('.emberk-faq__search-clear');
    /** @type {NodeListOf<HTMLButtonElement>} */
    this.categoryButtons = section.querySelectorAll('.emberk-faq__category');
    /** @type {NodeListOf<HTMLDetailsElement>} */
    this.faqItems = section.querySelectorAll('.emberk-faq__item');
    /** @type {HTMLElement | null} */
    this.resultsCount = section.querySelector('.emberk-faq__results-count');
    /** @type {HTMLElement | null} */
    this.resultsText = section.querySelector('.emberk-faq__results-text');
    /** @type {HTMLElement | null} */
    this.noResults = section.querySelector('.emberk-faq__no-results');
    /** @type {HTMLButtonElement | null} */
    this.clearFiltersBtn = section.querySelector('.emberk-faq__clear-filters');

    /** @type {string} */
    this.activeCategory = 'all';
    /** @type {string} */
    this.searchQuery = '';
    /** @type {string | null} */
    this.originalFAQList = null;
    /** @type {boolean} */
    this.groupByCategory = section.dataset.groupByCategory === 'true';

    this.init();
  }

  init() {
    // Search functionality
    if (this.searchInput) {
      this.searchInput.addEventListener('input', /** @param {Event} e */ (e) => {
        const target = /** @type {HTMLInputElement} */ (e.target);
        this.searchQuery = target.value.toLowerCase();
        this.updateSearchClear();
        this.filterFAQs();
      });
    }

    // Clear search button
    if (this.searchClear) {
      this.searchClear.addEventListener('click', () => {
        this.searchQuery = '';
        if (this.searchInput) {
          this.searchInput.value = '';
        }
        this.updateSearchClear();
        this.filterFAQs();
      });
    }

    // Category filtering
    this.categoryButtons.forEach(/** @param {HTMLButtonElement} button */ (button) => {
      button.addEventListener('click', () => {
        this.activeCategory = button.dataset.category || 'all';
        this.updateCategoryButtons();
        this.filterFAQs();
      });
    });

    // Clear filters button
    if (this.clearFiltersBtn) {
      this.clearFiltersBtn.addEventListener('click', () => {
        this.searchQuery = '';
        this.activeCategory = 'all';
        if (this.searchInput) this.searchInput.value = '';
        this.updateSearchClear();
        this.updateCategoryButtons();
        this.filterFAQs();
      });
    }

    // Initial count
    this.updateCategoryCounts();
    
    // Ensure no-results is hidden on initial load
    if (this.noResults) {
      this.noResults.hidden = true;
    }
    
    this.filterFAQs();
  }

  updateSearchClear() {
    if (this.searchClear) {
      this.searchClear.hidden = this.searchQuery.length === 0;
    }
  }

  updateCategoryButtons() {
    this.categoryButtons.forEach(/** @param {HTMLButtonElement} button */ (button) => {
      const isActive = button.dataset.category === this.activeCategory;
      button.classList.toggle('emberk-faq__category--active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    });
  }

  updateCategoryCounts() {
    /** @type {Record<string, number>} */
    const counts = {};
    counts['all'] = this.faqItems.length;

    this.faqItems.forEach(/** @param {HTMLDetailsElement} item */ (item) => {
      const category = item.dataset.category || '';
      counts[category] = (counts[category] || 0) + 1;
    });

    this.categoryButtons.forEach(/** @param {HTMLButtonElement} button */ (button) => {
      const category = button.dataset.category || '';
      const count = counts[category] || 0;
      button.dataset.count = String(count);
      const countSpan = button.querySelector('.emberk-faq__category-count');
      if (countSpan) {
        countSpan.textContent = `(${count})`;
      }
    });
  }

  filterFAQs() {
    let visibleCount = 0;
    const showGrouped = this.groupByCategory && this.activeCategory === 'all' && this.searchQuery.length === 0;

    // Get the FAQ list container
    const faqList = /** @type {HTMLElement | null} */ (this.section.querySelector('.emberk-faq__list'));
    
    if (showGrouped && faqList) {
      // Group FAQs by category
      this.renderGroupedFAQs(faqList);
      visibleCount = this.faqItems.length;
    } else if (faqList) {
      // Show flat list with filtering
      this.renderFlatFAQs(faqList);
      
      this.faqItems.forEach(/** @param {HTMLDetailsElement} item */ (item) => {
        const category = item.dataset.category || '';
        const question = (item.dataset.question || '').toLowerCase();
        const answer = (item.dataset.answer || '').toLowerCase();

        const matchesCategory = this.activeCategory === 'all' || category === this.activeCategory;
        const matchesSearch = this.searchQuery.length === 0 || 
                             question.includes(this.searchQuery) || 
                             answer.includes(this.searchQuery);

        const isVisible = matchesCategory && matchesSearch;
        item.hidden = !isVisible;

        if (isVisible) visibleCount++;
      });
    }

    // Update results count
    if (this.resultsCount && this.resultsText && this.searchInput) {
      if (this.searchQuery.length >= 2) {
        this.resultsCount.hidden = false;
        const plural = visibleCount === 1 ? 'result' : 'results';
        this.resultsText.textContent = `Found ${visibleCount} ${plural} for "${this.searchInput.value}"`;
      } else {
        this.resultsCount.hidden = true;
      }
    }

    // Show/hide no results message
    // Only show when user has actively searched or filtered
    const hasActiveFilter = this.searchQuery.length > 0 || this.activeCategory !== 'all';
    if (this.noResults) {
      this.noResults.hidden = !hasActiveFilter || visibleCount > 0;
    }
  }

  /**
   * Render FAQs grouped by category
   * @param {HTMLElement} container - The FAQ list container
   */
  renderGroupedFAQs(container) {
    // Store original items if not already stored
    if (!this.originalFAQList) {
      this.originalFAQList = container.innerHTML;
    }

    // Get categories from category buttons (excluding 'all')
    const categories = Array.from(this.categoryButtons)
      .map(btn => {
        const labelEl = /** @type {HTMLElement | null} */ (btn.querySelector('.emberk-faq__category-label'));
        const iconEl = /** @type {HTMLElement | null} */ (btn.querySelector('.emberk-faq__category-icon'));
        return {
          id: btn.dataset.category || '',
          label: labelEl ? labelEl.textContent || '' : '',
          icon: iconEl ? iconEl.outerHTML : ''
        };
      })
      .filter(cat => cat.id !== 'all');

    // Group FAQ items by category
    /** @type {Record<string, HTMLDetailsElement[]>} */
    const grouped = {};
    this.faqItems.forEach(/** @param {HTMLDetailsElement} item */ (item) => {
      const category = item.dataset.category || '';
      if (!grouped[category]) {
        grouped[category] = [];
      }
      // Clone the item and remove hidden attribute to ensure all items show
      const clonedItem = /** @type {HTMLDetailsElement} */ (item.cloneNode(true));
      clonedItem.removeAttribute('hidden');
      grouped[category].push(clonedItem);
    });

    // Build grouped HTML
    let groupedHTML = '';
    categories.forEach(category => {
      const categoryItems = grouped[category.id];
      if (categoryItems && categoryItems.length > 0) {
        groupedHTML += `
          <div class="emberk-faq__category-group">
            <div class="emberk-faq__category-header">
              ${category.icon}
              <h3 class="emberk-faq__category-title">${category.label}</h3>
            </div>
            ${categoryItems.map(/** @param {HTMLDetailsElement} item */ (item) => item.outerHTML).join('')}
          </div>
        `;
      }
    });

    container.innerHTML = groupedHTML;
    // Re-query FAQ items since we replaced the HTML
    this.faqItems = this.section.querySelectorAll('.emberk-faq__item');
  }

  /**
   * Render FAQs in flat list
   * @param {HTMLElement} container - The FAQ list container
   */
  renderFlatFAQs(container) {
    // Restore original flat list if we have it
    if (this.originalFAQList) {
      container.innerHTML = this.originalFAQList;
      // Re-query FAQ items since we replaced the HTML
      this.faqItems = this.section.querySelectorAll('.emberk-faq__item');
    }
  }
}

// Initialize all FAQ sections on the page
document.addEventListener('DOMContentLoaded', () => {
  const faqSections = document.querySelectorAll('[data-faq-section]');
  faqSections.forEach((section) => {
    if (section instanceof HTMLElement) {
      new EmberkFAQ(section);
    }
  });
});

// Also initialize when Shopify section is loaded (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  const target = event.target;
  if (target instanceof HTMLElement) {
    const faqSection = target.querySelector('[data-faq-section]');
    if (faqSection instanceof HTMLElement) {
      new EmberkFAQ(faqSection);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-emberk-product-card-grid"] && !Shopify.designMode) return;
  try {
    
/**
 * Emberk Product Card Grid - Variant Picker Handler
 * Handles dynamic variant selection and price updates on product cards
 */
class EmberkVariantPicker {
  constructor() {
    this.init();
  }

  init() {
    // Find all variant pickers on the page
    const variantPickers = document.querySelectorAll('[data-variant-picker]');
    
    variantPickers.forEach(picker => {
      this.setupPicker(picker);
    });
  }

  /**
   * Setup event listeners for a variant picker
   * @param {HTMLElement} picker - The variant picker container
   */
  setupPicker(picker) {
    const productId = picker.dataset.productId;
    const variantInputs = picker.querySelectorAll('[data-variant-input]');
    
    variantInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.handleVariantChange(e.target, productId);
      });
    });
  }

  /**
   * Handle variant selection change
   * @param {HTMLInputElement} input - The selected variant radio input
   * @param {string} productId - The product ID
   */
  handleVariantChange(input, productId) {
    const variantId = input.dataset.variantId;
    const price = input.dataset.price;
    const priceFormatted = input.dataset.priceFormatted;
    const subscriptionPrice = input.dataset.subscriptionPrice;
    const subscriptionPriceFormatted = input.dataset.subscriptionPriceFormatted;
    const compareAtPrice = input.dataset.compareAtPrice;
    const compareAtPriceFormatted = input.dataset.compareAtPriceFormatted;
    const savingsPercent = input.dataset.savingsPercent;
    const available = input.dataset.available === 'true';

    // Find the card container
    const card = input.closest('.emberk-pcg__card');
    if (!card) return;

    // Update variant option visual state
    this.updateVariantOptionState(input);

    // Update form variant IDs
    this.updateFormVariantIds(card, variantId, available);

    // Update price display (use compare_at_price for the crossed-out price)
    this.updatePriceDisplay(card, priceFormatted, subscriptionPriceFormatted, compareAtPriceFormatted);

    // Update savings badge
    this.updateSavingsBadge(card, savingsPercent);

    // Update "Try it once" button text
    this.updateOnetimeButtonText(card, priceFormatted);

    // Update button availability
    this.updateButtonAvailability(card, available);

    // Update price per serving
    this.updatePerServing(card, input);

    // Update product image
    this.updateProductImage(card, input);
  }

  /**
   * Update the visual state of variant options
   * @param {HTMLInputElement} selectedInput - The selected input
   */
  updateVariantOptionState(selectedInput) {
    const picker = selectedInput.closest('[data-variant-picker]');
    if (!picker) return;

    // Remove selected class from all options
    picker.querySelectorAll('.emberk-pcg__variant-option').forEach(option => {
      option.classList.remove('emberk-pcg__variant-option--selected');
    });

    // Add selected class to the selected option's parent
    const selectedOption = selectedInput.closest('.emberk-pcg__variant-option');
    if (selectedOption) {
      selectedOption.classList.add('emberk-pcg__variant-option--selected');
    }
  }

  /**
   * Update hidden variant ID inputs in forms
   * @param {HTMLElement} card - The product card container
   * @param {string} variantId - The new variant ID
   * @param {boolean} available - Whether the variant is available
   */
  updateFormVariantIds(card, variantId, available) {
    const variantIdInputs = card.querySelectorAll('[data-variant-id-input]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      input.disabled = !available;
    });
  }

  /**
   * Update the price display
   * @param {HTMLElement} card - The product card container
   * @param {string} priceFormatted - The formatted one-time price
   * @param {string} subscriptionPriceFormatted - The formatted subscription price
   * @param {string} compareAtPriceFormatted - The formatted compare-at price
   */
  updatePriceDisplay(card, priceFormatted, subscriptionPriceFormatted, compareAtPriceFormatted) {
    // Update subscription price (main price when subscriptions available)
    const subscriptionPriceEl = card.querySelector('[data-subscription-price]');
    if (subscriptionPriceEl) {
      subscriptionPriceEl.textContent = subscriptionPriceFormatted;
    }

    // Update compare price (use actual compare_at_price, shown crossed out)
    const comparePriceEl = card.querySelector('[data-compare-price]');
    if (comparePriceEl && compareAtPriceFormatted) {
      comparePriceEl.textContent = compareAtPriceFormatted;
    }

    // Update main price (when no subscriptions)
    const mainPriceEl = card.querySelector('[data-main-price]');
    if (mainPriceEl) {
      mainPriceEl.textContent = priceFormatted;
    }
  }

  /**
   * Update the savings badge
   * @param {HTMLElement} card - The product card container
   * @param {string} savingsPercent - The savings percentage
   */
  updateSavingsBadge(card, savingsPercent) {
    const savingsBadge = card.querySelector('[data-savings-badge]');
    if (!savingsBadge) return;

    const savings = parseInt(savingsPercent, 10);
    
    if (savings > 0) {
      savingsBadge.textContent = `SAVE ${savings}%`;
      savingsBadge.hidden = false;
    } else {
      savingsBadge.hidden = true;
    }
  }

  /**
   * Update the "Try it once" button text with new price
   * @param {HTMLElement} card - The product card container
   * @param {string} priceFormatted - The formatted one-time price
   */
  updateOnetimeButtonText(card, priceFormatted) {
    const onetimeButton = card.querySelector('[data-onetime-button]');
    if (!onetimeButton) return;

    const hasSubscription = onetimeButton.dataset.hasSubscription === 'true';
    if (!hasSubscription) return;

    const textPrefix = onetimeButton.dataset.buttonTextPrefix || 'Try it once';
    const buttonTextEl = onetimeButton.querySelector('[data-button-text]');
    
    if (buttonTextEl) {
      buttonTextEl.textContent = `${textPrefix} - ${priceFormatted}`;
    }
  }

  /**
   * Update button availability based on variant
   * @param {HTMLElement} card - The product card container
   * @param {boolean} available - Whether the variant is available
   */
  updateButtonAvailability(card, available) {
    const submitButtons = card.querySelectorAll('button[type="submit"]');
    submitButtons.forEach(button => {
      button.disabled = !available;
    });
  }

  /**
   * Update the price per serving display
   * @param {HTMLElement} card - The product card container
   * @param {HTMLInputElement} input - The selected variant radio input
   */
  updatePerServing(card, input) {
    const perServingEl = card.querySelector('[data-per-serving]');
    if (!perServingEl) return;

    const servings = parseInt(input.dataset.servings, 10);
    if (!servings) {
      perServingEl.textContent = '';
      return;
    }

    const hasSubscription = card.querySelector('[data-subscription-price]');
    const price = hasSubscription
      ? parseInt(input.dataset.subscriptionPrice, 10)
      : parseInt(input.dataset.price, 10);

    if (!price) return;

    const pps = (price / 100 / servings).toFixed(2);
    perServingEl.textContent = '$' + pps + ' per serving';
  }

  /**
   * Update the product card image when variant changes
   * @param {HTMLElement} card - The product card container
   * @param {HTMLInputElement} input - The selected variant radio input
   */
  updateProductImage(card, input) {
    const imageUrl = input.dataset.image;
    if (!imageUrl) return;

    const mainImage = card.querySelector('.emberk-pcg__image:not(.emberk-pcg__image--hover)');
    if (!mainImage) return;

    mainImage.src = imageUrl;
    mainImage.alt = input.dataset.imageAlt || '';
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new EmberkVariantPicker();
});

// Re-initialize on Shopify section events (for Theme Editor)
document.addEventListener('shopify:section:load', () => {
  new EmberkVariantPicker();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-emberk-testemonials"] && !Shopify.designMode) return;
  try {
    
class TestimonialsCarousel {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-carousel-track]');
    this.dots = section.querySelectorAll('[data-dot-index]');
    this.cards = section.querySelectorAll('[data-testimonial-index]');
    this.autoRotate = section.dataset.autoRotate === 'true';
    this.rotationSpeed = parseInt(section.dataset.rotationSpeed) || 5;
    
    this.currentIndex = 0;
    this.autoRotateTimer = null;
    this.isPaused = false;

    this.init();
  }

  init() {
    if (!this.track || this.cards.length === 0) return;

    this.setupEventListeners();
    this.updateCarousel();
    
    if (this.autoRotate) {
      this.startAutoRotate();
    }
  }

  setupEventListeners() {
    // Dot navigation
    this.dots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.dotIndex);
        this.goToSlide(index);
      });
    });

    // Pause on hover
    if (this.autoRotate && window.matchMedia('(hover: hover)').matches) {
      this.section.addEventListener('mouseenter', () => this.pauseAutoRotate());
      this.section.addEventListener('mouseleave', () => this.resumeAutoRotate());
    }

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    this.track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      this.pauseAutoRotate();
    });

    this.track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    });

    // Keyboard navigation
    this.section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.navigate('prev');
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.navigate('next');
      }
    });
  }

  handleSwipe(startX, endX) {
    const swipeThreshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        this.navigate('next');
      } else {
        this.navigate('prev');
      }
    }
  }

  navigate(direction) {
    const totalCards = this.cards.length;
    
    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % totalCards;
    } else {
      this.currentIndex = this.currentIndex === 0 ? totalCards - 1 : this.currentIndex - 1;
    }

    this.updateCarousel();
    this.resetAutoRotate();
  }

  goToSlide(index) {
    this.currentIndex = Math.max(0, Math.min(index, this.cards.length - 1));
    this.updateCarousel();
    this.resetAutoRotate();
  }

  updateCarousel() {
    const cardWidth = this.cards[0]?.offsetWidth || 0;
    const offset = this.currentIndex * cardWidth;

    this.track.style.transform = `translateX(-${offset}px)`;

    // Update dots
    this.dots.forEach((dot, index) => {
      const isActive = index === this.currentIndex;
      dot.classList.toggle('emberk-testimonials__dot--active', isActive);
      dot.setAttribute('aria-selected', isActive);
    });
  }

  startAutoRotate() {
    if (!this.autoRotate || this.isPaused) return;
    
    this.autoRotateTimer = setInterval(() => {
      this.navigate('next');
    }, this.rotationSpeed * 1000);
  }

  pauseAutoRotate() {
    this.isPaused = true;
    if (this.autoRotateTimer) {
      clearInterval(this.autoRotateTimer);
      this.autoRotateTimer = null;
    }
  }

  resumeAutoRotate() {
    this.isPaused = false;
    this.startAutoRotate();
  }

  resetAutoRotate() {
    if (this.autoRotate) {
      this.pauseAutoRotate();
      this.resumeAutoRotate();
    }
  }
}

// Initialize carousel
document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.emberk-testimonials');
  carousels.forEach(carousel => new TestimonialsCarousel(carousel));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
